<template>
    <div class="modal is-active">
        <div class="modal-background" />
        <div class="modal-content">
            <div class="box">
                <p class="is-size-5 has-text-centered">
                    {{ $t('project.configuration_changes') }}
                </p>
                <p class="is-size-6 has-text-centered px-4 py-5">
                    {{ $t('project.configuration_changes_text') }}
                </p>
                
                <div class="has-text-centered">
                    <button
                        class="button px-6 is-primary is-uppercase"
                        @click="$emit('toggle-configuration')"
                    >
                        {{ $t('Buttons.go_to_configuration') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'underscore';
export default {
    components: {},
    props: {
    },
    data() {
        return {};
    },
    computed: {
        
    },
    mounted() {},
    methods: {
    },
};
</script>

<style scooped>
</style>
